module.exports = __webpack_public_path__ + "img/6.ab1c7af0.jpg";